import jwtDefaultConfig from './jwtDefaultConfig';

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...jwtDefaultConfig, ...jwtOverrideConfig };
  }
}
